import { render, staticRenderFns } from "./HotSale.vue?vue&type=template&id=a36a3986&scoped=true"
import script from "./HotSale.vue?vue&type=script&lang=ts"
export * from "./HotSale.vue?vue&type=script&lang=ts"
import style0 from "./HotSale.vue?vue&type=style&index=0&id=a36a3986&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a3986",
  null
  
)

export default component.exports